import axios from "axios";

const axiosInstance = axios.create({
  baseURL: (window as any)?.Liferay?.ThemeDisplay?.getPortalURL(), // Replace with your API base URL
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  params: {
    p_auth: (window as any)?.Liferay?.authToken,
  }
});


axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
